import React, { memo } from 'react'
import { EmptyTableMessage } from 'src/components/payments-ops/EmptyTableMessage'
import { GridTable } from 'src/components/shared/grid/GridTable'
import { otherEarningsColumns } from 'src/constants/payments-ops/otherEarningsGrid'
import type { OtherEarning } from 'src/interfaces/paymentsReview'

interface Props {
  earnings: OtherEarning[]
  isLoading: boolean
}

const getRowId = (row: OtherEarning): string => {
  return row.id
}

const renderEmpty = () => {
  return <EmptyTableMessage message="No other earnings for this driver." />
}

/** Embedded history — `autoHeight` so it does not trap the modal's scroll. */
const OtherEarningsTableComponent = ({ earnings, isLoading }: Props) => {
  return (
    <GridTable<OtherEarning>
      rows={earnings}
      columns={otherEarningsColumns}
      getRowId={getRowId}
      isLoading={isLoading}
      autoHeight
      isStandalone
      sortingMode="client"
      hideFooter
      EmptyElement={renderEmpty}
      tableDataTestId="payments-review-other-earnings-table"
    />
  )
}

export const OtherEarningsTable = memo(OtherEarningsTableComponent)
